import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { UnidadeExecutoraService } from "../../services/UnidadeExecutoraService";
import { ExercicioService } from "../../services/ExercicioService";
export default {
    name: "GerenciarUnidadeExecutoras",
    components: {
        Breadcrumb,
        ActionButtons,
        StandardPagination
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Unidades Executoras',
                disabled: true,
                href: '/unidades-executoras',
            }
        ],
        // Propriedades de responsividade
        windowWidth: 0,
        isMobile: false,
        isTablet: false,
        headers: [
            { text: 'Exercício', align: 'center', value: 'exercicio', sortable: true },
            { text: 'Código Unidade Executora', align: 'center', value: 'codigo_unidade', sortable: true },
            { text: 'Descrição Unidade Executora', align: 'center', value: 'nome', sortable: true },
            { text: 'Status', align: 'center', value: 'ativo', sortable: true },
        ],
        filters: {
            codigoUnidadeExecutoraFilter: '',
            nomeUnidadeExecutoraFilter: '',
            exercicioFilter: null,
            statusFilter: null,
        },
        statusOptions: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
        ],
        itemsPerPage: 10,
        showFilters: true,
        loading: false,
        items: [],
        itemSelected: [],
        exerciciosOptions: [],
        page: 1,
        totalItems: 0
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        // Headers responsivos baseados no tamanho da tela
        computedHeaders() {
            const baseHeaders = [
                {
                    text: 'Exercício',
                    value: 'exercicio',
                    sortable: true,
                    align: 'center',
                    width: '120px',
                    priority: 3
                },
                {
                    text: 'Código Unidade Executora',
                    value: 'codigo_unidade',
                    sortable: true,
                    align: 'center',
                    width: '180px',
                    priority: 1
                },
                {
                    text: 'Descrição Unidade Executora',
                    value: 'nome',
                    sortable: true,
                    align: 'center',
                    width: '300px',
                    priority: 2
                },
                {
                    text: 'Status',
                    value: 'ativo',
                    sortable: true,
                    align: 'center',
                    width: '120px',
                    priority: 1
                }
            ];

            // Em dispositivos móveis, mostra apenas colunas prioritárias
            if (this.isMobile) {
                return baseHeaders.filter(header => header.priority <= 2);
            }
            // Em tablets, mostra a maioria das colunas
            else if (this.isTablet) {
                return baseHeaders.filter(header => header.priority <= 3);
            }
            // Desktop mostra todas as colunas
            return baseHeaders;
        }
    },
    created() {
        this.listarUnidadesExecutorasPaginado();
        this.listarExerciciosSelect();
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        'filters.codigoUnidadeExecutoraFilter': function() {
            this.page = 1;
            this.listarUnidadesExecutorasPaginado();
        },
        'filters.nomeUnidadeExecutoraFilter': function() {
            this.page = 1;
            this.listarUnidadesExecutorasPaginado();
        },
        'filters.exercicioFilter': function() {
            this.page = 1;
            this.listarUnidadesExecutorasPaginado();
        },
        'filters.statusFilter': function() {
            this.page = 1;
            this.listarUnidadesExecutorasPaginado();
        }
    },
    methods: {
        async listarUnidadesExecutorasPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await UnidadeExecutoraService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os Unidades Executoras.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Unidades Executoras:', error);
            } finally {
                this.loading = false;
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },
        getRowClass(item) {
            return item ? 'custom-row' : '';
        },
        navigateToCreate() {
            this.$router.push('/unidades-executoras/criar');
        },
        navigateToEdit() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/unidades-executoras/editar/${this.itemSelected[0].id}`);
            }
        },
        handleExport() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },
        handlePageChanged(newPage) {
            this.page = newPage;
            this.listarUnidadesExecutorasPaginado();
        },
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarUnidadesExecutorasPaginado();
        },
        async destroyUnidadesExecutoras() {
            try {
                const ids = this.itemSelected.map(unidadeExecutora => unidadeExecutora.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("unidadeExecutoras[]", id);
                });

                const response = await UnidadeExecutoraService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os Unidades Executoras.');
                }

                this.listarUnidadesExecutorasPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os Unidades Executoras:', error);
            }
        },
        async activateUnidadesExecutoras() {
            try {
                const ids = this.itemSelected.map(unidadeExecutora => unidadeExecutora.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("unidadeExecutoras[]", id);
                });

                const response = await UnidadeExecutoraService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os unidadeExecutoras.');
                }

                this.listarUnidadesExecutorasPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os unidadeExecutoras:', error);
            }
        },
        async deactivateUnidadesExecutoras() {
            try {
                const ids = this.itemSelected.map(unidadeExecutora => unidadeExecutora.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("unidadeExecutoras[]", id);
                });

                const response = await UnidadeExecutoraService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os unidadeExecutoras.');
                }

                this.listarUnidadesExecutorasPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os unidadeExecutoras:', error);
            }
        },
        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);

            if (this.filters.codigoUnidadeExecutoraFilter) {
                filter.append("codigo", this.filters.codigoUnidadeExecutoraFilter);
            }

            if (this.filters.nomeUnidadeExecutoraFilter) {
                filter.append("nome", this.filters.nomeUnidadeExecutoraFilter);
            }

            if (this.filters.exercicioFilter) {
                filter.append("exercicio", this.filters.exercicioFilter);
            }

            if (this.filters.statusFilter !== null) {
                filter.append("ativo", this.filters.statusFilter);
            }

            return filter;
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.isMobile = this.windowWidth < 768; // Exemplo de breakpoint para mobile
            this.isTablet = this.windowWidth < 992; // Exemplo de breakpoint para tablet
        }
    }
};
